import { ZealApiSuccessResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import type {
  TGetAiConversationMessagesRequestSchema,
  TGetAiConversationMessagesResponseSchema,
} from "./getAiConversationMessages.schema";

type TSuccess =
  ZealApiSuccessResponse<TGetAiConversationMessagesResponseSchema>;

export const getAiConversationMessages = (axios: IAxiosInstance) => {
  return async (
    params: TGetAiConversationMessagesRequestSchema
  ): Promise<TGetAiConversationMessagesResponseSchema> => {
    try {
      const response = await axios.noRetry.get<TSuccess>(
        `/api/ai/conversations/${encodeURIComponent(
          params.conversationId
        )}/messages`,
        {
          params: {
            companyId: params.companyId,
            userId: params.userId,
          },
        }
      );
      const body = response.data;
      if (body?.success === true) {
        return body.data;
      }
      throw new ZealClientError(response);
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
